export const REVIEW_PAGE_HEADER_DESCRIPTION = 'Review your source selections or go back to add more.'
